const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production' ? 'https://arabtechstore.com' : 'http://localhost:8032')

const SOCKET_BASE_URL =
  process.env.REACT_APP_SOCKET_URL ||
  (process.env.NODE_ENV === 'production' ? 'https://arabtechstore.com' : 'http://localhost:8032')

module.exports = {
  siteName: 'LIC Admin',
  copyright: 'Copyright © All rights reserved |  ',
  logoPath: '/image/logo.png',
  apiPrefix: API_BASE_URL,
  socketURL: SOCKET_BASE_URL,
  reportDownloadUrl: `${API_BASE_URL}/reports`,
  uploadMediaUrl: `${API_BASE_URL}/media`,
  apiURL: `${API_BASE_URL}/api`,
  importPolicyPlanUrl: `${API_BASE_URL}/api/policy/plan/import`,
}
